module.exports = __webpack_public_path__ + "img/core-value.711cd29c.png";